import { withStyles } from '@material-ui/core';

import PushForm from './component';
import styles from './styles';

export default withStyles(styles)(PushForm);
